function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { makeStyles } from "@material-ui/styles";
import { getInitialBreakpoint } from "./helpers";
import LeftArrow from "../Icons/LeftArrow";
import RightArrow from "../Icons/RightArrow";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  container: {
    position: "relative"
  },
  carousel: {
    paddingLeft: typography.pxToRem(10),
    paddingRight: typography.pxToRem(10),
    [breakpoints.up("sm")]: {
      paddingLeft: typography.pxToRem(50),
      paddingRight: typography.pxToRem(50)
    }
  },
  carouselWithoutArrows: {
    padding: 0
  },
  buttonContainer: {
    position: "absolute",
    top: 0,
    display: "flex",
    alignItems: "center",
    height: "100%"
  },
  buttonRightContainer: {
    right: 0,
    [breakpoints.down("xs")]: {
      marginRight: typography.pxToRem(-30)
    }
  },
  buttonLeftContainer: {
    left: 0,
    [breakpoints.down("xs")]: {
      marginLeft: typography.pxToRem(-30)
    }
  },
  leftArrowIcon: {
    "& .leftArrow": {
      stroke: palette.text.primary,
      strokeWidth: 3
    }
  },
  rightArrowIcon: {
    "& .rightArrow": {
      stroke: palette.text.primary,
      strokeWidth: 3
    }
  }
}));

const ArrowsCarousel = props => {
  const carouselRef = /*#__PURE__*/React.createRef();
  const {
    responsive = {},
    items = [],
    withoutArrows,
    arrowIconClassName,
    slideIndex,
    onSlideIndexChange
  } = props;
  const styles = useStyles();
  const [breakpoint] = React.useState(getInitialBreakpoint(responsive));
  const onSlideChanged = React.useCallback(e => {
    onSlideIndexChange(e.item);
  }, [onSlideIndexChange]);

  const slidePrev = () => carouselRef.current.slidePrev();

  const slideNext = () => carouselRef.current.slideNext();

  const showRightArrow = () => slideIndex < items.length - (responsive[breakpoint] ? responsive[breakpoint].items : 1);

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.carousel, {
      [styles.carouselWithoutArrows]: withoutArrows
    })
  }, /*#__PURE__*/React.createElement(AliceCarousel, _extends({
    ref: carouselRef,
    onSlideChanged: onSlideChanged,
    startIndex: slideIndex
  }, props))), !!slideIndex && !withoutArrows && /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.buttonContainer, styles.buttonLeftContainer)
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: slidePrev
  }, /*#__PURE__*/React.createElement(LeftArrow, {
    className: clsx(styles.leftArrowIcon, arrowIconClassName)
  }))), showRightArrow() && !withoutArrows && /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.buttonContainer, styles.buttonRightContainer)
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: slideNext
  }, /*#__PURE__*/React.createElement(RightArrow, {
    className: clsx(styles.rightArrowIcon, arrowIconClassName)
  }))));
};

export default ArrowsCarousel;